import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loaded: false,
  loading: false,
  data: {},
  error: null
})

const { Types, Creators } = createActions({
  getAllUsers: null,
  getAllUsersSuccess: ['data'],
  getAllUsersFailure: ['error'],
  removeUsersListener: null,
})

export const getAllUsersReducer = state =>
  state.set('loading', true).set('error', null)

export const getAllUsersSuccessReducer = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)
    .set('error', null)

export const getAllUsersFailureReducer = (state, { error }) =>
  state
    .set('data', {})
    .set('loading', false)
    .set('loaded', true)
    .set('error', error)

export const removeUsersListenerReducer = state => state.set('loaded', false)

export const userReducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALL_USERS]: getAllUsersReducer,
  [Types.GET_ALL_USERS_SUCCESS]: getAllUsersSuccessReducer,
  [Types.GET_ALL_USERS_FAILURE]: getAllUsersFailureReducer,

  [Types.REMOVE_USERS_LISTENER]: removeUsersListenerReducer,
})

export const UserTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js